import { render, staticRenderFns } from "./ProductRegistrationIframe.vue?vue&type=template&id=262666c0&"
import script from "./ProductRegistrationIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductRegistrationIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports